export const WARN_CODES = Object.freeze({
  INBOUND_FLOOD: "INBOUND_FLOOD",
  UNIDENTIFIABLE_LARGE_FRAME: "UNIDENTIFIABLE_LARGE_FRAME",
});
